<section class="home-hero">
  <div class="home-hero-photo">
    <div #myCarousel class="carousel slide carousel-fade">
      <div class="carousel-inner">
        @for (item of carousel; track item.name; let i = $index) {
          <div class="carousel-item" [class.active]="i === 0">
            <img [src]="item.name" [alt]="item.title_img" oncontextmenu="return false;">
          </div>
        }
      </div>
    </div>
  </div>

  <div class="home-hero-copy">
    <h1><span>Cerca nell'archivio della Misericordia di</span><span>Borgo San Lorenzo</span></h1>
    <form class="archive-search" (submit)="searchArchive(); $event.preventDefault()">
      <div class="archive-search-line">
        <label class="visually-hidden" for="archive-select">Archivio</label>
        <div class="archive-search-select">
          <select id="archive-select" [value]="choosenArchive.id.toString()" (change)="chooseArchive($event)">
            <option value="1">Archivio</option>
            <option value="2">Opere d'arte</option>
          </select>
          <i class="bi bi-chevron-down" aria-hidden="true"></i>
        </div>
        <label class="visually-hidden" for="archive-search">Ricerca</label>
        <input id="archive-search" type="text" [formControl]="search"
          placeholder="Nome, luogo o documento" (keydown.enter)="searchArchive()">
        <button class="archive-search-go" type="submit">Cerca</button>
      </div>
    </form>
    <button class="scroll-hint" type="button" (click)="scrollToMore()">
      <span>Scorri per maggiori informazioni</span>
      <i class="bi bi-chevron-down" aria-hidden="true"></i>
    </button>
  </div>
</section>

<div class="home container-xxl">
  <section id="in-evidenza" class="home-highlights">
    <div class="home-section-head">
      <div>
        <h2>In evidenza</h2>
        <p>Le schede in primo piano nell'archivio.</p>
      </div>
      <a class="catalog-link" routerLink="/archivioStorico">Consulta l'intero catalogo <i class="bi bi-arrow-right"></i></a>
    </div>

    <div class="home-grid">
      @for (card of cards; track card.id; let i = $index) {
        <app-card [obj_card]="card" [counter]="i + 1" [thumbnails]="thumbnails"></app-card>
      }
    </div>

    @if (authService.isLoggedIn() && (canEditArticle$ | async)) {
      <div class="home-edit">s
        <button class="edit-view" type="button" (click)="openPopup()">Modifica visualizzazione schede</button>
      </div>
    }
  </section>

  <section class="home-partners" aria-label="Partner">
    <div class="partner-row">
      <a href="https://www.estotemisericordes.it/" target="_blank" rel="noopener noreferrer">
        <img src="assets/img/estote.png" alt="">
        <span>Fondazione Estote Misericordes</span>
      </a>
      <a href="http://www.misericordia.net/" target="_blank" rel="noopener noreferrer">
        <img src="assets/img/logo.png" alt="">
        <span>Misericordia Borgo San Lorenzo</span>
      </a>
      <a href="https://www.fratres.it/" target="_blank" rel="noopener noreferrer">
        <img src="assets/img/fratres.png" alt="">
        <span>Fratres Donatori di sangue</span>
      </a>
      <div class="partner-item">
        <img src="assets/img/protezioneCivile.png" alt="">
        <span>Protezione Civile Mugello</span>
      </div>
    </div>
  </section>
</div>
